<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <!-- 搜索  新增-->
      <el-form
        :inline="true"
        :model="searchForm"
        :rules="searchRules"
        ref="searchForRef"
        label-width="100px"
        autocomplete="on"
        size="mini"
        label-position="right"
      >
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="全部商品" name="first">
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="产品名称:">
                  <el-input v-model="searchForm.name" clearable type="text"></el-input>
                </el-form-item>
                <el-form-item label="商品状态:">
                  <el-select
                    v-model="searchForm.is_on_sale"
                    style="width: 180px;"
                    placeholder="请选择类别"
                  >
                    <el-option
                      v-for="item in saleList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">

                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="品牌:">
                  <el-input v-model="searchForm.brand_name" clearable type="text"></el-input>
                </el-form-item>
                <el-form-item label="商品编码:">
                  <el-input v-model="searchForm.goods_sn" clearable type="text"></el-input>
                </el-form-item>
                <el-form-item label="商品ID:">
                  <el-input v-model="searchForm.goods_id" clearable type="text"></el-input>
                </el-form-item>
                <el-form-item label="商品类目:">
                  <el-input v-model="searchForm.cate_id" clearable type="text"></el-input>
                </el-form-item>
                <el-form-item label="审核状态:">
                  <el-select
                    v-model="searchForm.is_auth"
                    style="width: 180px;"
                    placeholder="请选择类别"
                  >
                    <el-option
                      v-for="item in authList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="searchSubmit()" icon="el-icon-search"> 搜索</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-button type="primary"   @click="addData">
                    <i class="el-icon-plus"></i>新增</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success"  @click="changeSale(1)"><i class="el-icon-top"></i>批量上架</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="danger"  @click="changeSale(2)"><i class="el-icon-bottom"></i>批量下架</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info"  @click="goExcel()"><i class="el-icon-download"></i>导出</el-button>
                </el-form-item>
              </el-col>
            </el-row>
        </el-tab-pane>
        <el-tab-pane label="未上架产品" name="second">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="产品名称:">
                <el-input v-model="searchForm.name" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="商品状态:">
                <el-select
                  v-model="searchForm.is_on_sale"
                  style="width: 180px;"
                  placeholder="请选择类别"
                >
                  <el-option
                    v-for="item in saleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">

                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="品牌:">
                <el-input v-model="searchForm.brand_name" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="商品编码:">
                <el-input v-model="searchForm.goods_sn" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="商品ID:">
                <el-input v-model="searchForm.goods_id" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="商品类目:">
                <el-input v-model="searchForm.cate_id" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="审核状态:">
                <el-select
                  v-model="searchForm.is_auth"
                  style="width: 180px;"
                  placeholder="请选择类别"
                >
                  <el-option
                    v-for="item in authList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="searchSubmit()" icon="el-icon-search"> 搜索</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button type="primary"   @click="addData">
                  <i class="el-icon-plus"></i>新增</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="success"  @click="changeSale(1)"><i class="el-icon-top"></i>批量上架</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger"  @click="changeSale(2)"><i class="el-icon-bottom"></i>批量下架</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="info"  @click="goExcel"><i class="el-icon-download"></i>导出</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="上架产品" name="third">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="产品名称:">
                <el-input v-model="searchForm.name" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="商品状态:">
                <el-select
                  v-model="searchForm.is_on_sale"
                  style="width: 180px;"
                  placeholder="请选择类别"
                >
                  <el-option
                    v-for="item in saleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">

                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="品牌:">
                <el-input v-model="searchForm.brand_name" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="商品编码:">
                <el-input v-model="searchForm.goods_sn" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="商品ID:">
                <el-input v-model="searchForm.goods_id" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="商品类目:">
                <el-input v-model="searchForm.cate_id" clearable type="text"></el-input>
              </el-form-item>
              <el-form-item label="审核状态:">
                <el-select
                  v-model="searchForm.is_auth"
                  style="width: 180px;"
                  placeholder="请选择类别"
                >
                  <el-option
                    v-for="item in authList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="searchSubmit()" icon="el-icon-search"> 搜索</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button type="primary"   @click="addData">
                  <i class="el-icon-plus"></i>新增</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger"  @click="changeSale(2)"><i class="el-icon-bottom"></i>批量下架</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="info"  @click="goExcel"><i class="el-icon-download"></i>导出</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="下架产品" name="fourth">

        </el-tab-pane>
        <el-tab-pane label="已删除" name="fiveth">

        </el-tab-pane>
      </el-tabs>
      </el-form>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        size="mini"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="产品名称"
          width="350"
          prop="goods_name"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="所属分类"
          width="120"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.category!=null?scope.row.category.cat_name:""}}
               {{scope.row.category==null?scope.row.cat_id:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="销售价格"
          width="100"
          prop="shop_price"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="市场价格"
          width="100"
          prop="market_price"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="一件代发价格"
          width="100"
          prop="cost_price"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="产品编码"
          width="100"
          prop="goods_sn"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="品牌名称"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.brand!=null?scope.row.bran.name:""}}
           </span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品状态"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.is_on_sale|isSale }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="审核状态"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.is_auth|isAuth }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发布日期"
          width="140"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.add_time | dateFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="160">
          <template slot-scope="scope">
            <el-button  type="text" size="small" @click="del(scope.row)">删除</el-button>
            <el-button @click="handleClick(scope.row)"  type="text" size="small">编辑</el-button>
            <el-button @click="relationCar(scope.row)"  type="text" size="small">关联轮毂</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->


    <el-drawer
            title="车辆列表"
            :visible.sync="drawerCar"
            :with-header="false">
      <el-table
              style="margin-top: 20px;"
              ref="multipleTable"
              :data="carList"
              size="mini"
              stripe
              border
      >
        <!--        <el-table-column label="" width="50" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-radio v-model="curHub" :label="scope.row" @input="clickChange(scope.row,scope.$index)">{{ "" }}</el-radio>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column  type="index" label="序号" width="50"></el-table-column>
        <el-table-column
                label="图片"
                width="150"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <el-image
                    style="width: 50px; height: 50px"
                    :src="scope.row.file_url"
                    :fit="fit"
                    :preview-src-list="[scope.row.file_url]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
                label="车型"
                width="150"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.style&&scope.row.style.parent?scope.row.style.parent.name:''}}
                {{scope.row.style?scope.row.style.name:''}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
                label="孔距"
                width="80"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.pitch?scope.row.pitch.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="市场价"
                width="80"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.market_price}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="margin-top:10px">
        <el-pagination
                background
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="pageNum1"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total1">
        </el-pagination>
      </div>
    </el-drawer>

  </div>
</template>

<script>
  import moment from 'moment'     //日期时间转换
  export default {
    name: "simpleGoodsList",
    components: {
    },
    props: {},
    data() {
      return {
        pitch_id:'',
        drawerCar:false,
        carList:[],
        total1:0,
        pageNum1:1,
        pageSize1:20,

        is_del:0,
        saleList:[{id:0,name:'未上架'},{id:1,name:'上架'},{id:2,name:'下架'}],
        authList:[{id:0,name:'待审核'},{id:1,name:'已审核'},{id:2,name:'上级驳回'}],
        activeName:'first',
        multipleSelection:[],
        shop_id:sessionStorage.getItem('shop_id'),
        // 搜索
        searchForm: {
          name: "",
          shop_name:'',
          is_on_sale:'',
          brand_name:'',
          goods_sn:'',
          goods_id:'',
          cate_id:'',
          is_auth:''
        },
        searchRules: {
          name: [
            { required: true, message: "请输入文章标题", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入保司名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        },

      };
    },
    created() {
      this.showType = this.$route.query.showType;
      console.log(this.showType,888);
      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },
      isAuth(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "上级驳回";
        }
      },
      isSale(status) {
        if (status == 0) {
          return "未上架";
        } else if (status == 1) {
          return "已上架";
        } else if (status == 2) {
          return "下架";
        }
      },
    },
    methods: {
      goExcel(){

      },
      relationCar(row){
        this.drawerCar=true;
        this.pitch_id=row.pitch_id;
        this.getCarList();
      },
      getCarList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum1:this.pageNum1,
          pageSize1: this.pageSize1,
          pitch_id:this.pitch_id
        }
        this.$axios.findCarListP(param).then(res=>{
          if(res.code == 200){
            //  console.log(res,1111);
            this.carList = res.data.data
            this.total1 = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      handleSizeChange1(newSize) {
        this.pageSize1 = newSize
        this.getCarList()
      },
      // 分页跳转
      handleCurrentChange1(newPage) {
        this.pageNum1 = newPage
        this.getCarList()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tabClick(e){
        console.log(e)
        if(this.activeName=='fiveth'){
          this.is_on_sale='';
          this.is_del=1;
          this.pageNum=1;
          this.DataList();
        }else{
          if(this.activeName=='fourth'){
            this.is_on_sale=2;
          }else if(this.activeName=='third'){
            this.is_on_sale=1;
          }else if(this.activeName=='second'){
            this.is_on_sale=0;
          }else if(this.activeName=='first'){
            this.is_on_sale='';
          }
          this.is_del=0;
          this.pageNum=1;
          this.DataList();
        }
      },
      handleClick(row){
        this.$router.push('/simpleGoodsForm?id='+row.goods_id)
      },
      goCategory(){
        this.$router.push('/goodsCategoryList')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id: sessionStorage.getItem('shop_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          is_del:this.is_del,
          is_on_sale:this.is_on_sale,
        }
        if(this.searchForm.name){
           param.keywords=this.searchForm.name;
        }
        this.$axios.findByShopGoodsListP(param).then(res=>{
          if(res.code == 200){
            //  console.log(res,1111);
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        // this.title = '新增'
        // this.form = {
        //   name: '',
        // }
        // this.dialogFormVisible = true
        this.$router.push('/simpleGoodsForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      searchSubmit() {
        this.tableLoadData=[];
        this.pageNum=1;
        this.DataList();
      },
      changeSale(type) {
        //请选择产品
        if(this.multipleSelection.length>0){
          console.log('this.multipleSelection',this.multipleSelection)
          let ids=[];
          this.multipleSelection.forEach((item)=>{
            ids.push(item.goods_id)
          })
          let msg="";
          let is_on_sale=0;
          if(type==1){
            msg='您是否上架该产品?'
            is_on_sale=1;
          }else if(type==2){
            msg='您是否下架该产品?';
            is_on_sale=2;
          }
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const param = {
              operator_id: sessionStorage.getItem('user_id'),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              goods_ids: ids.join(","),
              is_on_sale:is_on_sale
            }
            this.$axios.goodsChange(param).then(res=>{
              if(res.code == 200){
                this.$message.success('操作成功');
                this.pageNum=1;
                this.DataList()
              }else{
                this.$message.error(res.msg);
              }
            }).catch(error=>{
              console.log(error);
            })
          });
        }
      },
      del(e) {
        console.log('del----',e);
        this.$confirm('此操作将删除该产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            goods_id: e.goods_id,
            is_del:1
          }
          this.$axios.delGoods(param).then(res=>{
            if(res.code == 200){
              this.$message.success('删除成功');
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
